// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { Loading } from 'element-ui';
/**
 * title:导出文件标题
 * invoice: true为导出图片 false导出pdf
 */
export default {
  install (Vue, options) {
    Vue.prototype.getPdf = function ({ title, noScrollBar, invoice, cb }) {
      let loadingInstance = Loading.service({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.3)',
        text: '导出中...'
      });
      var shareContent = document.getElementById('ImageExportDom'); //需要截图的包裹的（原生的）DOM 对象
      var width = shareContent.offsetWidth; //获取dom 宽度
      var height = shareContent.offsetHeight; //获取dom 高度
      var canvas = document.createElement("canvas");
      canvas.width = width * 2;
      canvas.height = height * 2;
      canvas.style.width = width + "px";
      canvas.style.height = height + "px";
      var context = canvas.getContext("2d");
      context.scale(2, 2);
      var opts = {
        canvas: canvas,
        scale: 1, // 添加的scale 参数
        logging: true, //日志开关
        useOverflow: true,
        backgroundColor: '#ffffff',
      };
      html2Canvas(shareContent, opts).then(canvas => {
        if (invoice) {
          var IMAGE_URL = canvas.toDataURL("image/jpeg", 0.5);
          var a = document.createElement('a');
          a.href = IMAGE_URL;
          a.setAttribute('download', title ? title : '新媒体事业部消耗表系统');
          a.click();
          loadingInstance.close()
          cb ? cb() : ''
          // compressImg(IMAGE_URL,{
          //   quality: 0.5
          // },function (base64Codes) {
          //   // 下载图片base64
          //   //base64Codes即图片压缩完成后拿到的base64文档流

          // })

        } else {
          const contentWidth = canvas.width
          const contentHeight = canvas.height
          // 一页pdf显示html页面生成的canvas高度;
          var pageHeight = contentWidth / 592.28 * 841.89
          // 未生成pdf的html页面高度
          var leftHeight = contentHeight
          // pdf页面偏移
          var position = 0
          // html页面生成的canvas在pdf中图片的宽高（a4纸的尺寸[595.28,841.89]）
          const imgWidth = 592.28
          const imgHeight = 592.28 / contentWidth * contentHeight
          const pageData = canvas.toDataURL('image/jpeg', 0.5)
          const PDF = new jsPDF('p', 'pt', 'a4')
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', noScrollBar ? 0 : -2, 10, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', noScrollBar ? 0 : -2, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              // 避免添加空白页
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(title + '.pdf')
          loadingInstance.close()
          cb ? cb() : ''
        }

      })
    }
  }
}

function compressImg (path, obj, callback) {
  var img = new Image();
  img.src = path;
  img.onload = function () {
    var that = this;
    // 默认按比例压缩
    var w = that.width,
      h = that.height,
      scale = w / h;
    w = obj.width || w;
    h = obj.height || (w / scale);
    var quality = 0.7;  // 默认图片质量为0.7
    //生成canvas
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    // 创建属性节点
    var anw = document.createAttribute("width");
    anw.nodeValue = w;
    var anh = document.createAttribute("height");
    anh.nodeValue = h;
    canvas.setAttributeNode(anw);
    canvas.setAttributeNode(anh);
    // drawImage画布绘制的方法。(0,0)表示以Canvas画布左上角为起点，w，h是将图片按给定的像素进行缩小。
    // 如果不指定缩小的像素图片将以图片原始大小进行绘制，图片像素如果大于画布将会从左上角开始按画布大小部分绘制图片，最后的图片就是张局部图。
    ctx.drawImage(that, 0, 0, w, h);
    // 图像质量
    if (obj.quality && obj.quality <= 1 && obj.quality > 0) {
      quality = obj.quality;
    }
    // quality值越小，所绘制出的图像越模糊
    var base64 = canvas.toDataURL('image/jpeg', quality);
    // 回调函数返回base64的值
    callback(base64);
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/htmlToPdf.js